import AnalyticsDashboardAppConfig from './dashboards/analytics/AnalyticsDashboardAppConfig';
import DemoAppConfig from './demo/DemoAppConfig';
import ListCategoryAppConfig from './listCategory/ListCategoryAppConfig';

const appsConfigs = [AnalyticsDashboardAppConfig, DemoAppConfig, ListCategoryAppConfig];

export default appsConfigs;
